





























/* Created- 28 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardXL.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { ButtonConfig } from "../../../Models/Buttons";
import { ParticaEvent, eParticaAction, getActionName } from "../../../Models/ParticaEvent";

import axios from "axios";
import { IIssueConversionService } from "../../../BusinessServices/issueconversion";
import ParticaIssueBase from "../../Base/ParticaIssueBase.vue";
import { IIssueService } from "../../../BusinessServices/issue";
import { ConversionLogModel } from "../../../Generated/ParticaAPI";
import IssueConversionLog from "../../../Ui-Components/Issue/IssueConversionLog.vue";


@Component(
	{
		name: "IssueConversion",
		components: {
			ButtonList,
			ParticaCard,
			ParticaView,
			IssueConversionLog
		}
	})
export default class IssueConversion extends ParticaIssueBase {
	@Prop() private id: number;
	private conversionService: IIssueConversionService;
	private issueService: IIssueService;
	private data: ConversionLogModel[] = [];

	private buttons: ButtonConfig[] = [
		// { label: "Add new title", action: eParticaAction.ISSUE_ADD, type: ButtonType.Normal } as ButtonConfig,
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				case eParticaAction.PDF_UPLOAD: {
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		}
	}

	@Watch("route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Issue Conversion";
		await this.init();
		await this.getIssueNav(this.id);
	}

	private async init() {
		try {
			this.LoadingStart();
			this.conversionService = this.particaServices.getIssueConversionService();
			this.issueService = this.particaServices.getIssueService();
			this.data = await this.conversionService.getConversionLog(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
